import * as React from 'react';
import { Button } from 'react-bootstrap';
import { getAvailability, getAvailabilityColor, getEsHs, formatPhone, displayShortened } from '../../utility/api-utilities';
import { AppContext } from '../school-search-app';
import { PAGE_MODE, SCHOOL_TYPE } from '../../interfaces';
import { getPageProperties } from '../../services/cps-school-api';

function ResultCard(props) {
    const school = props.school;
    const duration = [school._epi.fullYear ? school._epi.fullYear : null, school._epi.schoolYear ? school._epi.schoolYear : null].filter(x => x != null).join(', ');
    const day = [school._epi.fullDayProgram ? school._epi.fullDayProgram : null, school._epi.partDayProgram ? school._epi.partDayProgram : null].filter(x => x != null).join(', ');
    const [isChecked, setIsChecked] = React.useState(false)
    const appContext = React.useContext(AppContext);
    const cpsPrek = (appContext.mode == PAGE_MODE.PREK && school.type == SCHOOL_TYPE.CPS);

    React.useEffect(() => {
        setIsChecked(props.compareSchools.lemgth == 0 ? false : props.compareSchools.some(s => s._epi.id === school._epi.id));
    }, [props.compareSchools]);

    const header = <button className="header" onClick={() => {
        if (appContext.mode == PAGE_MODE.GOCPS && props.profileRedirectUrl) {
            // @ts-ignore
            window.open('' + props.profileRedirectUrl + school._epi.id, '_blank');
        } else {
            props.schoolInfo(school._epi.id)
        }
    }}>
        <h2>{school._tag && school._tag == 'Neighborhood School' ? <span className="neighborhood-icon" role="img" aria-label="Neighborhood school icon"></span> : ''}
            {appContext.mode == 'prog' ? school._epi.schoolShortName : school._epi.title}</h2>
    </button>


    const cpsSocials = (school) => {
        let socials = [];
        if (school._epi.facebookURL) socials.push({ fa: 'facebook', url: school._epi.facebookURL });
        if (school._epi.twitterURL) socials.push({ fa: 'twitter', url: school._epi.twitterURL });
        if (school._epi.youtubeURL) socials.push({ fa: 'youtube', url: school._epi.youtubeURL });
        return <span className="card-socials">
            {socials.map(s => <a href={s.url} aria-label={s.fa} key={s.fa} target="blank"><span className={`fab fa-${s.fa}`}> </span></a>)}
        </span>
    }

    const moreInfoHTML = (school) => {
        if (props.profileRedirectUrl) {
            const url = '' + props.profileRedirectUrl + school._epi.id;
            <a href={url} target="_blank"> More Info </a>
        }

        return <a onClick={() => props.schoolInfo(school._epi.id)}> More Info </a>
    }

    const moreInfoButton = appContext.mode == PAGE_MODE.GOCPS ? cpsSocials : moreInfoHTML;

    const viewOnMap = (school) => {
        props.setOnViewOnMapClick(true)
        props.focusMap(school._epi.id);
        appContext.addSchoolOverlay(school._epi.id);
    }

    const address = <div className="address section">
        <p>{school._epi.address}</p>
        <p>{formatPhone(school._epi.phoneNumber)}</p>
        <p className="card-links">
            <a onClick={() => viewOnMap(school)}>View On Map</a>
            {appContext.mode != 'prog' ? moreInfoButton(school) : <></>}
        </p>
    </div>

    const cpsDetails = <div className="details section">
        <p><strong>Grades Served: </strong>{school._epi.gradesOffered}</p>
        <p><strong>Number of Students: </strong>{school._epi.studentCount}</p>
    </div>

    let progDetails;
    if (appContext.mode == PAGE_MODE.SUMMER_PROGRAMM) {
        const sortedPrograms = school._epi.summerPrograms.sort((a, b) => {
            let aName = a.name;
            if (aName == 'HS Credit Recovery' || aName == 'Local Programming' || aName == 'CTE Summer Camps') {
                aName = `${a.name} - ${a.programCategories}`
            }
            let bName = b.name;
            if (bName == 'HS Credit Recovery' || bName == 'Local Programming' || aName == 'CTE Summer Camps') {
                bName = `${b.name} - ${b.programCategories}`
            }
            return aName.localeCompare(bName)
        });
        progDetails = <div className="details section">
            <table>
                <thead>
                    <tr>
                        <th>Program</th>
                        <th>Grade</th>
                        <th>Days</th>
                        <th>Duration</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedPrograms.map((program, i) => {
                        let displayName = program.name;
                        if (displayName == 'HS Credit Recovery' || displayName == 'Local Programming' || displayName == 'CTE Summer Camps') {
                            displayName = `${program.name} - ${program.programCategories}`
                        }
                        return <tr key={`program${i}`}>
                            <td>{displayName}</td>
                            <td>{program.gradesServed}</td>
                            <td>{displayShortened(program.durationDays)}</td>
                            <td>{displayShortened(program.startDate)}{program.endDate ? ` - ${displayShortened(program.endDate)}` : ''}</td>
                        </tr>
                    })}
                </tbody>
            </table>
        </div>
    }

    const circleClass = `circle ${getAvailabilityColor(school._epi.availability)}`;

    const prekDetails = <div className="details section">
        <p><strong>School Type: </strong>{cpsPrek ? 'CPS-Based' : 'Community Based'}</p>
        <p><strong>Duration: </strong>{cpsPrek ? 'School Year' : duration}</p>
        <p><strong>School Day: </strong>{day}</p>
        <p><strong>Seats Available: <span className={circleClass}></span> </strong>{school._epi.availability}</p>
    </div>

    // @todo clean up the copy / paste of more info
    const cpsActions = <div className="result-card-actions section">
        <label><input type="checkbox" onChange={e => props.compareSchool(school, e.target.checked)} checked={isChecked} />Compare</label>
        {props.profileRedirectUrl ? 
            <a className="btn simple" target="_blank" href={'' + props.profileRedirectUrl + school._epi.id} >More Info</a> :
            <a className="btn simple" onClick={() => props.schoolInfo(school._epi.id)}>More Info</a>
        }
    </div>

    const prekActions = <div className="result-card-actions prek section">
        <label><input type="checkbox" onChange={e => props.compareSchool(school, e.target.checked)} checked={isChecked} />Compare</label>
        <a className="btn simple" target="_blank" href="https://cps.schoolmint.com">Apply</a>
    </div>

    const progActions = <div className="result-card-actions prog section">
        <a className="btn simple" onClick={() => props.schoolInfo(school._epi.id)}>More Info</a>
    </div>

    let details;
    let actions;
    let gradeType;

    if (appContext.mode == PAGE_MODE.GOCPS) {
        details = cpsDetails;
        actions = cpsActions;
        gradeType = getEsHs(school);
    }
    else if (appContext.mode == PAGE_MODE.SUMMER_PROGRAMM) {
        details = progDetails;
        actions = progActions;
        gradeType = '';
    }
    else { //prek
        details = prekDetails;
        actions = prekActions;
        gradeType = '';
    }

    return (
        <div className='card-cell' data-schoolid={school._epi.id}>
            <div className={`result-card ${school.type} ${gradeType} ${school._tag && school._tag == 'Neighborhood School' ? 'neighborhood-school' : ''} ${appContext.mode}`}>
                {header}
                <div className="section-container">{address}</div>
                <div className="section-container">{details}</div>
                <div className="section-container">{actions}</div>
            </div>
        </div>
    )
}

export default ResultCard;
